var render, staticRenderFns
import script from "./HeroDropdown.vue?vue&type=script&lang=js"
export * from "./HeroDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119cb62e",
  null
  
)

export default component.exports